import Api from '.';

class UserApi extends Api {
  base_endpoint = 'users';

  invite(data) {
    return this.doRequest('post', `invite`, data);
  }

  getInvite(id, params) {
    return this.doRequest('get', `invite/${id}`, params);
  }

  updateRoles(user_id, role_ids) {
    return this.doRequest('put', `${user_id}/roles`, { role_ids });
  }

  updatePassword(user_id, data) {
    return this.doRequest('put', `${user_id}/password`, data);
  }

  getMe(user_id) {
    return this.doRequest('get', `${user_id}/me`);
  }

  toggleAdmin(user_id, company_id, is_admin) {
    return this.doRequest('put', `${user_id}/admin`, { company_id, is_admin });
  }
}

export default new UserApi();
